import {Observable, throwError, timer} from 'rxjs';
import {mergeMap} from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';

export const genericRetryStrategy = (
  {
    maxRetryAttempts = 5,
    scalingDuration = 1000,
    excludedStatusCodes = [],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }: RetryStrategyParams) => (attempts: Observable<any>) => {
  return attempts.pipe(
    mergeMap((error: HttpErrorResponse, i: number) => {

      maxRetryAttempts = maxRetryAttempts || maxRetryAttempts !== 0 ? 5 : 0;
      scalingDuration = scalingDuration || 1000;
      excludedStatusCodes = excludedStatusCodes || [];

      if (error.status === 401) {
        localStorage.clear();
      }

      const retryAttempt: number = i + 1;
      if (
        retryAttempt > maxRetryAttempts ||
        excludedStatusCodes.find((e: number) => e === error.status)
      ) {
        return throwError(error);
      }

      return timer(retryAttempt * scalingDuration);
    })
  );
};

export interface RetryStrategyParams {
  maxRetryAttempts?: number | null;
  scalingDuration?: number | null;
  excludedStatusCodes?: number[] | null;
}
